import React, { useContext, useEffect } from 'react'
import PermanenceFilterHeader from '../../../components/Permanence/PermanenceFilterHeader'
import PermanenceReportContext from '../../../context/PermanenceReportContext/PermanenceReportContext'
import PermanenceTabletFilters from '../../../components/Permanence/PermanenceTabletFilters';
import useWindowSize from '../../../customHooks/useWindowSize';
import { Spinner } from 'reactstrap';
import CustomPagination from '../../../components/CustomPagination/CustomPagination';
import ErrorScreen from '../../../components/MessagesScreens/ErrorScreen';
import useGetDateAndHour from '../../../customHooks/useGetDateAndHour';
import PermanenceDetailList from '../../../components/Permanence/PermanenceDetail/PermanenceDetailList';
import PermanenceTable from '../../../components/Permanence/PermanenceTable/PermanenceTable';

const Permanence = () => {

    const { handleGetPermanenceReport, permanenceReportState, getPermanenceReport } = useContext(PermanenceReportContext);
    const { reportFilter, isFetching, totalPages, error, message } = permanenceReportState;

    const { windowWidth } = useWindowSize();
    const { systemDate, isFetchingSystemDate } = useGetDateAndHour();

    const handlePaginate = (page) => {
        getPermanenceReport({
            ...reportFilter,
            reg_from: page
        })
    }

    const getPermanenceReportDefault = () => {
        const haveDates = !!reportFilter.date_from.trim() && !!reportFilter.date_to.trim();
        if (haveDates && isFetchingSystemDate === false) {
            handleGetPermanenceReport(reportFilter);
        } else {
            if (isFetchingSystemDate === false) {
                const filter = {
                    ...reportFilter,
                    date_from: systemDate.split(' ')[0],
                    date_to: systemDate.split(' ')[0],
                }
                handleGetPermanenceReport(filter)
            }
        }
    }

    useEffect(() => {
        getPermanenceReportDefault()
        // eslint-disable-next-line
    }, [isFetchingSystemDate])

    return (
        <div className="ps-4 pe-4 h-100 d-flex flex-column justify-content-between">
            <div className='mt-4'>
                <PermanenceFilterHeader />
                <PermanenceTabletFilters />
                {isFetching && (
                    <div className="d-flex justify-content-center">
                        <Spinner />
                    </div>
                )}
                {error && (
                    <ErrorScreen
                        title={'Error'}
                        description={message}
                    />
                )}
                {(!isFetching && !error) && (windowWidth >= 655 ? <PermanenceTable /> : <PermanenceDetailList />)}
            </div>
            <div className="d-flex justify-content-center pt-4 pb-4">
                <CustomPagination
                    totalPages={totalPages}
                    page={reportFilter.reg_from}
                    setPage={handlePaginate}
                    disabled={isFetching}
                />
            </div>
        </div>
    )
}

export default Permanence